<template>
  <!-- 头部 开始 -->
  <Navigation :nav_select="1"></Navigation>
  <!-- 头部 结束 -->
  <div v-if="loding" v-loading="loding" element-loading-background="rgba(0, 0, 0, 0.1)" element-loading-text="数据加载中" class="loding_div"></div>
  <main>
    <!-- 第一屏 开始 -->
    <div class="one_screen">
      <div class="one_screen_title">
        <img src="../assets/h14.png" alt="">
        <!-- <h1>古籍检索</h1> -->
      </div>
      <Search />
      <div class="one_screen_tab" @click="ToBookList">
        <span>共收录{{ bookcount }}部古籍，查看书库</span>
        <el-icon><ArrowRight /></el-icon>
      </div>
    </div>
    <!-- 第一屏 结束 -->
    <!-- 第二屏 开始 -->
    <div class="two_screen" v-if="book_type.length > 0">
      <div class="two_screen_web">
        <div class="two_screen_left">
          <img src="../assets/h4.png" alt="">
        </div>
        <div class="two_screen_right">
          <div class="two_screen_right_detail">
            <div class="two_screen_right_detail_top" v-if="isMobileDevice">
              <div class="type_bu" v-for="(item, index) in book_type" :key="index" @click="bindbook_typechange(index)">{{ item.name }}</div>
            </div>
            <div class="two_screen_right_detail_top" v-if="!isMobileDevice">
              <div class="type_bu" v-for="(item, index) in book_type" :key="index" @mouseover="bindbook_typechange(index)" @click="bindbook_type2change(index)">{{ item.name }}</div>
            </div>
            <div class="two_screen_right_detail_bottom">
              <img src="../assets/h6.png" alt="">
              <div class="p" v-html="setShengLue(book_type[book_type_index].catetext)"></div>
            </div>
          </div>
          <div class="two_screen_right_title">
            <img src="../assets/h15.png" alt="">
            <!-- <p>古籍分类</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 第二屏 结束 -->
    <!-- 第三屏 开始 -->
    <div class="three_screen" v-if="book_list.length > 0">
      <div class="three_screen_web">
        <div class="three_screen_left" v-if="isMobileDevice">
          <img :src="book_list[book_list_index].image" alt="" @click="bindbookdetailchange(book_list[book_list_index].num)">
        </div>
        <div class="three_screen_left_3D" v-if="!isMobileDevice">
          <Home3D :key="book_list_index" style="width: 100%;height: 100%" :book_info="book_list[book_list_index]" @handelbook3Dread="handelbook3Dread"></Home3D>
        </div>
        <div class="three_screen_right">
          <div class="three_screen_right_detail">
            <div class="three_screen__tab">
              <div class="three_screen__tab_img">
                <img src="../assets/h11.png" alt="" @click="bindbooklistchange(1)">
              </div>
              <p>{{ book_list[book_list_index].bookname }}</p>
              <div class="three_screen__tab_img">
                <img src="../assets/h12.png" alt="" @click="bindbooklistchange(2)">
              </div>
            </div>
            <div class="three_screen_right_content">
              <p class="p1"><span>{{ book_list[book_list_index].descript }}</span></p>
              <p class="p2">{{ book_list[book_list_index].abstract }}</p>
            </div>
            <div class="three_screen__tab_list">
              <img src="../assets/h9.png"></img>
              <div :class="book_list_index == index ? 'three_screen__tab___book tab_red' : 'three_screen__tab___book'" v-for="(item, index) in book_list" :key="item.id" @click="bindbookhuanchange(index)">《{{ item.bookname }}》</div>
            </div>
          </div>
          <div class="three_screen_right_title">
            <img src="../assets/h16.png" alt="">
            <!-- <p>推荐图书</p> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 第三屏 结束 -->
    <div class="book3D" v-if="book3Dread">
      <book3D :book_info="book_list[book_list_index]" @handelbook3Dreadoff="handelbook3Dreadoff"></book3D>
    </div>
  </main>
  <!-- 底部 开始 -->
  <Footer></Footer>
  <!-- 底部 结束 -->
</template>
<script setup>
  import Navigation from "../components/Navigation.vue";
  import Search from "../components/Search.vue";
  import Footer from "../components/Footer.vue";
  import Home3D from "../components/Home3D.vue";
  import book3D from "../components/3Dbook.vue";
  import { ref, reactive, onMounted, onBeforeUnmount } from 'vue';
  import { post } from '@/services/api';
  import { ElMessage } from 'element-plus';
  import { useRouter, useRoute } from "vue-router";
  const router = useRouter();
  const route = useRoute();

  const loding = ref(true);

  const book3Dread = ref(false);

  const bookcount = ref(0);
  const book_type_index = ref(0);
  const book_type = reactive([]);
  const book_list_index = ref(0);
  const book_list = reactive([]);
  // 切换古籍分类
  function bindbook_typechange(index){
    book_type_index.value = index;
  };
  const bindbook_type2change=(index)=>{
    let fdc = book_type[index].name;
    let fdc_id = book_type[index].id;
    router.push({
      name: "AncientWorks",
      query: {
        fdc: fdc,
        fdc_id: fdc_id,
      },
    })
  };
  // 切换推荐图书
  function bindbooklistchange(type){
    switch (type) {
      case 1:
        // 上一个
        if(book_list_index.value <= 0){
          return
        }
        book_list_index.value = Number(book_list_index.value)-1;
        break;
    
      case 2:
        // 下一个
        if(book_list_index.value >= book_list.length - 1){
          return
        }
        book_list_index.value = Number(book_list_index.value)+1;
        break;
    }
  }
  // 切换推荐图书
  const bindbookhuanchange=(index)=>{
    book_list_index.value = index;
  };
  // 读书
  const handelbook3Dread=async(type)=>{
    book3Dread.value = type;
  };
  const handelbook3Dreadoff=async(type)=>{
    book3Dread.value = type;
  };
  
  const isMobileDevice = ref(false);
  onMounted(() => {
    getuserAgent();
    window.addEventListener('resize', getuserAgent); // 监听窗口大小变化
    // 在组件挂载时调用 API 获取数据
    getHomeIndex();
  });
  onBeforeUnmount(() => {
    window.removeEventListener('resize', getuserAgent); // 移除监听
  });
  // 通过 userAgent 判断是否是移动设备
  const getuserAgent = ()=>{
    const userAgent = navigator.userAgent.toLowerCase();
    isMobileDevice.value = /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(userAgent);
  };
  // 获取首页信息
  const getHomeIndex=async()=>{
    try {
      const response = await post('/api/index/index');  // 发送请求
      // 请求成功
      const res = response.data;
      bookcount.value = res.bookcount;
      book_type.splice(0, book_type.length, ...res.catelist);
      book_list.splice(0, book_list.length, ...res.booklist);
      loding.value = false;
    } catch (err) {
      // 请求失败
      ElMessage({
        message: err,
        type: 'error',
      })
    } finally {
      // 请求结束
    }
  };
  const ToBookList =()=>{
    router.push({
      name: "AncientWorks"
    })
  };
  const bindbookdetailchange=(num)=>{
    router.push({
      name: "VolumeList",
      query: {num},
    })
  };
  const setShengLue=(text)=>{
    let text_linshi = "";
    console.log(text.length)
    if(text.length > 130){
     text_linshi = text.slice(0, 130) + " · · ·";
    }else{
     text_linshi = text;
    }
    return text_linshi
  };
</script>
<style scoped>
.loding_div{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
}
main{
  width: 100%;
}
/* 第一屏 开始 */
.one_screen{
  width: 100%;
  height: calc(100vh - 60px);
  min-height: 700px;
  background-image: url("../assets/h_bj1.png");
  background-size: cover;
}
.one_screen_title{
  width: 600px;
  margin: 0 auto 0;
  padding: 207px 0 27px;
  text-align: center;
}
.one_screen_title img{
  width: 100%;
}
.one_screen_title h1{
  font-family: monospace;
  font-family: 'inpin duobaotabeijian';
  font-weight: 400;
  font-size: 72px;
  color: #565554;
  line-height: 56px;
}
.one_screen_tab{
  width: 388px;
  height: 72px;
  margin: 35px auto 0;
  background-image: url("../assets/h3.png");
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.one_screen_tab span{
  font-weight: 400;
  font-size: 18px;
  color: #222222;
  margin-right: 18px;
  transition: 0.5s;
}
.one_screen_tab:hover span{
  font-size: 20px;
}
@media screen and (max-width: 1210px) {
  .one_screen{
    height: auto;
    min-height: auto;
    padding-bottom: 168px;
  }
  .one_screen_title{
    width: 454px;
    padding: 98px 0 40px;
  }
  .one_screen_title h1{
    font-size: 48px;
  }
}
@media screen and (max-width: 750px) {
  .one_screen{
    height: auto;
    min-height: auto;
    padding-bottom: 84px;
  }
  .one_screen_title{
    width: 247px;
    padding: 49px 0 20px;
  }
  .one_screen_title h1{
    font-size: 48px;
  }
  /* .one_screen_tab{
    zoom: 0.7;
  } */
  .one_screen_tab{
    width: 271.6px;
    height: 50.4px;
    margin: 24.5px auto 0;
    background-image: url("../assets/h3.png");
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .one_screen_tab span{
    font-weight: 400;
    font-size: 12.6px;
    color: #222222;
    margin-right: 12.6px;
    transition: 0.5s;
  }
  .one_screen_tab:hover span{
    font-size: 15px;
  }
}
@media screen and (max-width: 450px) {
  .one_screen_tab{
    display: none;
  }
}
/* 第一屏 结束 */

/* 第二屏 开始 */
.two_screen{
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-image: url("../assets/h_bj2.png");
  background-size: cover;
  padding: 80px 0 252px;
}
.two_screen_web{
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media screen and (min-width: 1237px) {
  .two_screen_web{
    transform: scale(0.8);
  }
}
.two_screen_left{
  width: 629px;
  margin-right: 87px;
}
.two_screen_left img{
  width: 629px;
}
.two_screen_right{
  display: flex;
  align-items: center;
}
.two_screen_right_detail{
  margin-right: 57px;
}
.two_screen_right_detail_top{
  width: 736px;
  display: flex;
  justify-content: space-between;
}
.type_bu{
  width: 75px;
  height: 234px;
  background-image: url("../assets/h5.png");
  background-size: cover;
  font-weight: 400;
  font-size: 30px;
  color: #565554;
  writing-mode: vertical-rl; /* 文字从上到下，从右到左 */
  display: grid; /* 使用 CSS Grid */
  place-items: center; /* 水平垂直居中 */
  cursor: pointer;
}
.type_bu:hover{
  color: #000000;
}
.two_screen_right_detail_bottom{
  width: 736px;
  height: 460px;
  background-color: rgb(241,239,235);
  margin-top: 40px;
  position: relative;
}
.two_screen_right_detail_bottom img{
  width: 375px;
  height: 306px;
  position: absolute;
  left: -36px;
  bottom: 0;
}
.two_screen_right_detail_bottom .p{
  width: 100%;
  font-weight: 400;
  font-size: 24px;
  color: #565554;
  line-height: 60px;
  text-decoration-line: overline;
  writing-mode: vertical-rl; /* 文字从上到下，从右到左 */
  text-align: justify;
  padding: 30px 58px 50px 0;
  box-sizing: border-box;
}
.two_screen_right_title{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.two_screen_right_title img{
  width: 108px;
}
.two_screen_right_title p{
  font-family: inpin duobaotabeijian;
  font-weight: 400;
  font-size: 60px;
  color: #565554;
  line-height: 56px;
  writing-mode: vertical-rl; /* 文字从上到下，从右到左 */
  margin-top: 34px;
}
@media (min-width: 1360px) and (max-width: 1634px) {
  .two_screen_left{
    width: 529px;
    margin-right: 60px;
  }
  .two_screen_left img{
    width: 529px;
  }
  .two_screen_right_detail{
    margin-right: 30px;
  }
  .two_screen_right_detail_top{
    width: 616px;
  }
  .type_bu{
    width: 70px;
  }
  .two_screen_right_detail_bottom{
    width: 616px;
  }
  /* .two_screen{
    zoom: 0.8;
  } */
}
@media (min-width: 1236px) and (max-width: 1360px) {
  .two_screen_left{
    width: 460px;
  }
  .two_screen_left img{
    width: 460px;
  }
  .two_screen_right_detail_top{
    width: 516px;
  }
  .two_screen_right_detail_bottom{
    width: 516px;
  }
  .two_screen_right_detail_bottom img{
    width: 310px;
    height: 252px;
  }
  .two_screen_right_title img{
    width: 80px;
  }
  .two_screen_right_detail_bottom .p{
    padding: 30px 20px 30px 0;
  }
  .two_screen_right_title p{
    font-size: 48px;
    margin-top: 20px;
  }
  /* .two_screen{
    zoom: 0.6;
  } */
}
@media screen and (min-width: 1000px) and (max-width: 1236px) {
  .two_screen{
    padding: 260px 0 152px;
    position: relative;
  }
  .two_screen_left{
    width: 333px;
    margin-right: 20px;
  }
  .two_screen_left img{
    width: 333px;
  }
  .two_screen_right_detail{
    margin-right: 20px;
  }
  .two_screen_right_detail_top{
    width: 900px;
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
  .type_bu{
    width: 68px;
    height: 210px;
    font-size: 26px;
  }
  .two_screen_right_detail_bottom{
    width: 453px;
    height: 371px;
    margin-top: 50px;
  }
  .two_screen_right_detail_bottom img{
    width: 200px;
    height: 163px;
    left: -6px;
  }
  .two_screen_right_detail_bottom .p{
    width: 100%;
    font-size: 20px;
    line-height: 44px;
    padding: 16px 18px 16px 0;
  }
  .two_screen_right_title img{
    width: 68px;
  }
  .two_screen_right_title p{
    font-size: 36px;
    line-height: 36px;
    margin-top: 22px;
  }
}
@media screen and (max-width: 1000px) {
  .two_screen{
    padding: 260px 0 152px;
    position: relative;
  }
  .two_screen_left{
    width: 270px;
    margin-right: 10px;
  }
  .two_screen_left img{
    width: 270px;
  }
  .two_screen_right_detail{
    margin-right: 26px;
  }
  .two_screen_right_detail_top{
    width: 654px;
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
  .type_bu{
    width: 68px;
    height: 210px;
    font-size: 26px;
  }
  .two_screen_right_detail_bottom{
    width: 340px;
    height: 300px;
    margin-top: 50px;
  }
  .two_screen_right_detail_bottom img{
    width: 166px;
    height: 134px;
    left: -6px;
  }
  .two_screen_right_detail_bottom .p{
    width: 100%;
    font-size: 18px;
    line-height: 33px;
    padding: 16px 13px 16px 0;
  }
  .two_screen_right_title img{
    width: 68px;
  }
  .two_screen_right_title p{
    font-size: 36px;
    line-height: 36px;
    margin-top: 22px;
  }
}
@media (min-width: 500px) and (max-width: 750px) {
  /* .two_screen{
    zoom: 0.66;
  } */
  .two_screen{
    padding: 171.6px 0 100.32px;
    position: relative;
  }
  .two_screen_left{
    width: 178.2px;
    margin-right: 6.6px;
  }
  .two_screen_left img{
    width: 178.2px;
  }
  .two_screen_right_detail{
    margin-right: 17.16px;
  }
  .two_screen_right_detail_top{
    width: 431.64px;
    position: absolute;
    top: 33px;
    left: 50%;
    transform: translateX(-50%);
  }
  .type_bu{
    width: 44.88px;
    height: 138.6px;
    font-size: 17.16px;
  }
  .two_screen_right_detail_bottom{
    width: 224.4px;
    height: 198px;
    margin-top: 33px;
  }
  .two_screen_right_detail_bottom img{
    width: 109.56px;
    height: 88.44px;
    left: -4px;
  }
  .two_screen_right_detail_bottom .p{
    width: 100%;
    font-size: 12px;
    line-height: 22px;
    padding: 10.56px 8px 10.56px 0;
  }
  .two_screen_right_title img{
    width: 44.88px;
  }
  .two_screen_right_title p{
    font-size: 23.76px;
    line-height: 23.76px;
    margin-top: 14.52px;
  }
}
@media screen and (max-width: 500px) {
  /* .two_screen{
    zoom: 0.5;
  } */
  .two_screen{
    padding: 130px 0 76px;
    position: relative;
  }
  .two_screen_left{
    width: 135px;
    margin-right: 5px;
  }
  .two_screen_left img{
    width: 135px;
  }
  .two_screen_right_detail{
    margin-right: 13px;
  }
  .two_screen_right_detail_top{
    width: 327px;
    position: absolute;
    top: 25px;
    left: 50%;
    transform: translateX(-50%);
  }
  .type_bu{
    width: 34px;
    height: 105px;
    font-size: 13px;
  }
  .two_screen_right_detail_bottom{
    width: 170px;
    height: 150px;
    margin-top: 25px;
  }
  .two_screen_right_detail_bottom img{
    width: 83px;
    height: 67px;
    left: -3px;
  }
  .two_screen_right_detail_bottom .p{
    width: 100%;
    font-size: 10px;
    line-height: 14px;
    padding: 8px 9px 8px 0;
  }
  .two_screen_right_title img{
    width: 34px;
  }
  .two_screen_right_title p{
    font-size: 18px;
    line-height: 18px;
    margin-top: 11px;
  }
}
/* 第二屏 结束 */
/* 第三屏 开始 */
.three_screen{
  width: 100%;
  padding: 260px 0 126px;
  position: relative;
  margin-top: -165px;
  z-index: 2;
  background-image: url("../assets/h_bj3.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.three_screen_web{
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
@media screen and (min-width: 1237px) {
  .three_screen_web{
    transform: scale(0.8);
  }
}
.three_screen_left{
  width: 323px;
  height: 535px;
  margin-right: 204px;
  cursor: pointer;
}
.three_screen_left_3D{
  width: 526px;
  height: 535px;
  cursor: pointer;
}
.three_screen_left img{
  width: 323px;
}
.three_screen_right{
  display: flex;
  align-items: center;
}
.three_screen_right_detail{
  margin-right: 100px;
}
.three_screen__tab{
  display: flex;
  align-items: center;
}
.three_screen__tab_img{
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.three_screen__tab_img img{
  width: 24px;
  cursor: pointer;
  transition: 0.2s;
}
.three_screen__tab img:hover{
  width: 28px;
}
.three_screen__tab p{
  padding: 0 25px;
  font-family: inpin duobaotabeijian;
  font-weight: 400;
  font-size: 66px;
  color: #FFFFFF;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.three_screen_right_content{
  max-width: 883px;
}
.three_screen_right_content .p1{
  height: 88px;
  font-size: 29px;
  color: #FFFFFF;
  line-height: 44px;
  margin-top: 36px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.three_screen_right_content .p2{
  height: 160px;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 32px;
  margin-top: 34px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
}
.three_screen__tab_list{
  width: 561px;
  height: 76px;
  padding: 0 18px;
  box-sizing: border-box;
  /* background-image: url("../assets/h9.png");
  background-size: cover;
  background-position: center; */
  display: flex;
  align-items: center;
  margin-top: 66px;
  position: relative;
}
.three_screen__tab_list img{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  z-index: 0;
}
.three_screen__tab___book{
  height: 54px;
  line-height: 54px;
  padding: 0 15px;
  font-family: inpin duobaotabeijian;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  z-index: 1;
}
/* .three_screen__tab___book:nth-last-child(1){
  margin-right: 0;
} */
.tab_red{
  background-color: rgba(199,158,96,0.3);
}
.three_screen_right_title{
  display: flex;
  align-items: center;
  flex-direction: column;
}
.three_screen_right_title img{
  width: 108px;
}
.three_screen_right_title p{
  font-family: inpin duobaotabeijian;
  font-weight: 400;
  font-size: 60px;
  color: #FDFAF6;
  line-height: 56px;
  writing-mode: vertical-rl; /* 文字从上到下，从右到左 */
  margin-top: 34px;
}
@media (min-width: 1360px) and (max-width: 1634px) {
  /* .three_screen_left{
    width: 280px;
    margin-right: 60px;
  }
  .three_screen_left img{
    width: 280px;
  } */
  /* .three_screen{
    zoom: 0.8;
  }
  .three_screen__tab_list{
    zoom: 0.8;
  } */
  .three_screen_right_detail{
    margin-right: 30px;
  }
  .three_screen_right_content{
    max-width: 680px;
  }
}
@media (min-width: 1236px) and (max-width: 1360px) {
  .three_screen_left{
    margin-right: 60px;
  }
  .three_screen_right_detail{
    margin-right: 30px;
  }
  .three_screen__tab p{
    font-size: 52px;
  }
  .three_screen_right_content{
    max-width: 560px;
  }
  .three_screen_right_title img{
    width: 80px;
  }
  .three_screen_right_title p{
    font-size: 48px;
    margin-top: 20px;
  }
  /* .three_screen{
    zoom: 0.6;
  }
  .three_screen__tab_list{
    zoom: 0.8;
  } */
}
@media screen and (min-width: 1000px) and (max-width: 1236px) {
  .three_screen{
    padding: 102px 0 126px;
    margin-top: -102px;
    position: relative;
    align-items: center;
  }
  .three_screen_left{
    width: 176px;
    margin-right: 26px;
  }
  .three_screen_left_3D{
    width: 386px;
    cursor: pointer;
  }
  .three_screen_left img{
    width: 176px;
  }
  .three_screen_right_detail{
    margin-right: 8px;
  }
  .three_screen__tab img{
    width: 18px;
    height: 24px;
  }
  .three_screen__tab p{
    padding: 0 20px;
    font-size: 48px;
    max-width: 351px;
  }
  .three_screen_right_content{
    max-width: 416px;
  }
  .three_screen_right_content .p1{
    height: 72px;
    font-size: 24px;
    line-height: 36px;
    margin-top: 20px;
    }
  .three_screen_right_content .p2{
    height: 120px;
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
  }
  .three_screen__tab_list{
    width: 490px;
    height: 66px;
    padding: 0 20px;
    margin-top: 26px;
    position: absolute;
    right: 13%;
  }
  .three_screen__tab___book{
    height: 48px;
    line-height: 48px;
    padding: 0 0px;
    font-size: 24px;
  }
  .three_screen_right_title img{
    width: 68px;
  }
  .three_screen_right_title p{
    font-weight: 400;
    font-size: 36px;
    line-height: 36px;
    margin-top: 20px;
  }
}
@media screen and (max-width: 1000px) {
  .three_screen{
    padding: 102px 0 126px;
    margin-top: -102px;
    position: relative;
    align-items: center;
  }
  .three_screen_left{
    width: 176px;
    margin-right: 26px;
  }
  .three_screen_left_3D{
    width: 300px;
    cursor: pointer;
  }
  .three_screen_left img{
    width: 176px;
  }
  .three_screen_right_detail{
    margin-right: 8px;
  }
  .three_screen__tab img{
    width: 18px;
    height: 24px;
  }
  .three_screen__tab p{
    padding: 0 20px;
    font-size: 40px;
    max-width: 351px;
  }
  .three_screen_right_content{
    max-width: 416px;
  }
  .three_screen_right_content .p1{
    height: 72px;
    font-size: 20px;
    line-height: 36px;
    margin-top: 20px;
    }
  .three_screen_right_content .p2{
    height: 120px;
    font-size: 16px;
    line-height: 24px;
    margin-top: 16px;
  }
  .three_screen__tab_list{
    width: 420px;
    height: 56px;
    padding: 0 16px;
    margin-top: 26px;
    position: absolute;
    right: 13%;
  }
  .three_screen__tab___book{
    height: 36px;
    line-height: 36px;
    padding: 0 0px;
    font-size: 18px;
  }
  .three_screen_right_title img{
    width: 68px;
  }
  .three_screen_right_title p{
    font-weight: 400;
    font-size: 36px;
    line-height: 36px;
    margin-top: 20px;
  }
}
@media (min-width: 750px) and (max-width: 900px) {
  .three_screen__tab_list {
    right: 5%;
  }
}
@media (min-width: 750px) and (max-width: 800px) {
  .three_screen__tab p{
    font-size: 32px;
  }
}
@media (min-width: 500px) and (max-width: 750px) {
  /* .three_screen_left{
    height: auto;
  }
  .three_screen{
    zoom: 0.66;
  }
  .three_screen__tab_list{
    position: absolute;
    right: 23px;
  } */
  .three_screen{
    padding: 67.32px 0 83.16px;
    margin-top: -67.32px;
    position: relative;
    align-items: center;
  }
  .three_screen_left{
    width: 116.16px;
    margin-right: 17.16px;
  }
  .three_screen_left_3D{
    width: 198px;
    height: 198px;
    cursor: pointer;
  }
  .three_screen_left img{
    width: 116.16px;
  }
  .three_screen_right_detail{
    margin-right: 5.28px;
  }
  .three_screen__tab img{
    width: 11.88px;
    height: 15.84px;
  }
  .three_screen__tab p{
    padding: 0 13.2px;
    font-size: 20px;
    max-width: 231.66px;
  }
  .three_screen_right_content{
    max-width: 274.56px;
  }
  .three_screen_right_content .p1{
    height: 47.52px;
    font-size: 13.2px;
    line-height: 23.76px;
    margin-top: 13.2px;
  }
  .three_screen_right_content .p2{
    height: 79.2px;
    font-size: 10.56px;
    line-height: 15.84px;
    margin-top: 10.56px;
  }
  .three_screen__tab_list{
    width: 277.2px;
    height: 36.96px;
    padding: 0 10.56px;
    margin-top: 17.16px;
    position: absolute;
    right: 13%;
  }
  .three_screen__tab___book{
    height: 23.76px;
    line-height: 23.76px;
    padding: 0 0px;
    font-size: 11.88px;
  }
  .three_screen_right_title img{
    width: 44.88px;
  }
  .three_screen_right_title p{
    font-weight: 400;
    font-size: 23.76px;
    line-height: 23.76px;
    margin-top: 13.2px;
  }
}
@media screen and (max-width: 500px) {
  /* .three_screen_left{
    height: auto;
  }
  .three_screen{
    zoom: 0.5;
  } */
  .three_screen{
    padding: 51px 0 63px;
    margin-top: -51px;
    position: relative;
    align-items: center;
  }
  .three_screen_left{
    width: 88px;
    height: auto;
    margin-right: 6px;
  }
  .three_screen_left_3D{
    width: 150px;
    cursor: pointer;
  }
  .three_screen_left img{
    width: 88px;
    height: 166px;
  }
  .three_screen_right_detail{
    margin-right: 0px;
  }
  .three_screen__tab img{
    width: 9px;
    height: 12px;
  }
  .three_screen__tab img:hover{
    width: 9px;
    height: 12px;
  }
  .three_screen__tab p{
    padding: 0 10px;
    font-size: 18px;
    max-width: 175px;
  }
  .three_screen_right_content{
    max-width: 208px;
  }
  .three_screen_right_content .p1{
    height: 36px;
    font-size: 10px;
    line-height: 18px;
    margin-top: 10px;
    }
  .three_screen_right_content .p2{
    height: 60px;
    font-size: 7px;
    line-height: 12px;
    margin-top: 8px;
  }
  .three_screen__tab_list{
    width: 210px;
    height: 28px;
    padding: 0 8px;
    margin-top: 13px;
    position: absolute;
    right: 3%;
  }
  .three_screen__tab___book{
    height: 18px;
    line-height: 18px;
    padding: 0 0px;
    font-size: 9px;
  }
  .three_screen_right_title img{
    width: 34px;
  }
  .three_screen_right_title p{
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    margin-top: 10px;
  }
}
/* 第三屏 结束 */
.book3D{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>